import { BasePalette } from './base-palette.js';

const Palette = new BasePalette();

export {
    Palette
}